<aside
  class="ui-app-sidebar"
  [class.ui-app-sidebar--collapsed]="collapsed()"
  [class.ui-app-sidebar--portal]="variant() === 'portal'"
>
  @if (variant() === 'portal' && logoSrc()) {
    <div class="ui-app-sidebar__brand">
      <img
        class="ui-app-sidebar__logo"
        [src]="collapsed() && collapsedLogoSrc() ? collapsedLogoSrc()! : logoSrc()!"
        [alt]="logoAlt()"
        loading="eager"
      />
    </div>
  }

  <nav [attr.aria-label]="ariaLabel()">
    <ul class="ui-app-sidebar__list" role="menubar" aria-orientation="vertical">
      @for (item of items(); track item.value) {
        @if (item.sectionTitle) {
          <li class="ui-app-sidebar__section-title" role="presentation">
            {{ item.sectionTitle }}
          </li>
        }
        <li class="ui-app-sidebar__li" role="none">
          <button
            type="button"
            class="ui-app-sidebar__item"
            role="menuitem"
            [class.ui-app-sidebar__item--active]="
              item.value === selectedValue()
            "
            [disabled]="item.disabled ?? false"
            [uiTooltip]="collapsed() ? item.label : ''"
            uiTooltipPosition="right"
            (click)="onItemClick(item)"
          >
            @if (item.iconSrc) {
              <img
                class="ui-app-sidebar__icon"
                [src]="item.iconSrc"
                alt=""
                aria-hidden="true"
                width="18"
                height="18"
              />
            }
            <span class="ui-app-sidebar__label">{{ item.label }}</span>
          </button>
        </li>
      }
    </ul>
  </nav>
</aside>
